<template>
  <v-container fluid class="px-0 py-0">
    <CoreBomSheetTable
        title=""
        dto-list-query="BomSheetPanasonicListQueryDTO"
        :store-name="storeTableName"
        :height="height - 260"
        :headers="headers"
        :detail-store-name="storeDetailName"
        :hide-default-footer="true"
        :hide-default-header="true"
        :show-select="true"
        :main-validator="false"
        :row-background="rowBackground"
    >
      <template v-slot:item.supply_type="{item}">
              <ChoiceSupplyType :item="item">
              </ChoiceSupplyType>
      </template>
    </CoreBomSheetTable>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreBomDetail from "@/components/CoreComponent/Bom/CoreBomDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import CoreBomSheetTable from "@/components/CoreComponent/BomSheet/CoreBomSheetTable";
import {useDetailStore} from "@/components/Common/CommonDetail";
import ChoiceSupplyType from "@/components/CoreComponent/ProductOrder/ChoiceSupplyType";
import CommonHTMXComponent from "@/components/Common/CommonHTMXComponent.vue";

export default {
  name: "CoreBomPanasonicTable",

  props: {
    height: {default: null},
    product_order_uid: {default: null}
  },

  components: {
    CommonHTMXComponent,
    CommonTable,
    CoreBomDetail,
    BaseFieldCheck,
    CoreBomSheetTable,
    ChoiceSupplyType,
  },

  watch: {
    product_order_uid: {
      handler(newValue, oldValue) {
        // console.log('watch BomDetail uidItem', newValue, oldValue)
        this.filterTable()
        this.storeDetail.parentUid = this.product_order_uid
        this.storeTable.uidItem = this.product_order_uid
      },
      deep: true
    },
  },

  methods: {
    rowBackground(item) {
      if (item.panasonic_error_status === 'ERROR')
        return 'red lighten-4'
      if (item.panasonic_error_status === 'WARNING')
        return 'orange lighten-4'
      if (item.panasonic_error_status === 'SUCCESS')
        return 'green lighten-4'
    },
    filterTable() {
      this.storeTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'product_order__uid', value: this.product_order_uid, enable: true},
        ],
        enable: true,
      }
    },
  },


  mounted() {
    this.storeDetail = useDetailStore(this.storeDetailName)()
    this.storeAggregate = useAggregateStore()
    this.storeTable = useTableStore(this.storeTableName)()
    this.storeTable.options.itemsPerPage = -1
    this.storeTable.options.sortBy = ['order']
    this.storeTable.options.sortDesc = [true]
    this.storeTable.footerProps = {'items-per-page-options': [5, 20, 50, 100, 200, -1]}
    this.filterTable()
    this.storeDetail.parentUid = this.product_order_uid
    this.storeTable.uidItem = this.product_order_uid
  },

  data() {
    return {
      dialogQualityControl: false,
      storeDetail: null,
      storeDetailName: uuidv4(),
      storeAggregate: null,
      storeTable: null,
      storeTableName: uuidv4(),
      headers: [
        {
          text: 'Status',
          value: 'row_panasonic_statuses',
          sortable: false,
          filterable: true,
          divider: true,
          align: 'center',
          width: 10,
          type: 'status'
        },
        {text: 'Task', value: 'task_dto', sortable: false, filterable: true, divider: true, width: 10},
        {text: 'Edit', value: 'edit', sortable: false, filterable: true, divider: true, width: 10},
        // {text: 'QA', value: 'check_qa_params', sortable: false, filterable: true, divider: true, type: 'bool', width: 10},
        {
          text: 'Do not place',
          value: 'do_not_place',
          sortable: false,
          filterable: true,
          divider: true,
          type: 'bool',
          align: 'center',
          color: 'green',
          width: 10
        },
        {text: 'Checked', value: 'attributes_checked', sortable: false, divider: true, width: 10, type: 'bool'},
        {
          text: 'Provided by customer',
          value: 'provided_by_customer',
          sortable: false,
          filterable: true,
          divider: true,
          type: 'bool',
          align: 'center',
          color: 'green',
          width: 10
        },
        {text: 'QTY', value: 'qty', sortable: true, filterable: true, divider: true, align: 'right', width: 50},
        {
          text: 'QTY P&P',
          value: 'quantity_pick_place',
          sortable: true,
          filterable: true,
          divider: true,
          align: 'right',
          width: 50
        },
        // {text: 'QTY Material', value: 'reservation_quantity', sortable: true, align: 'right', divider: true, width: 50},
        // {text: 'Still need', value: 'material_still_need_qty', sortable: true, align: 'right', divider: true, width: 50},
        {
          text: 'Designator',
          value: 'designator',
          sortable: true,
          align: 'center',
          divider: true,
          width: 250,
          type: 'text'
        },
        {text: 'Article', value: 'component__article', sortable: true, align: 'end', divider: true, width: 50},
        {text: 'Alias', value: 'component__alias', sortable: true, align: 'right', divider: true, width: 250},
        {
          text: 'Type',
          value: 'component__case_package__type',
          sortable: false,
          align: 'center',
          divider: true,
          width: 70
        },
        {text: 'Layers', value: 'layers', sortable: false, align: 'center', divider: true, width: 70},
        {
          text: 'Category',
          value: 'component__subcategory__category__category',
          sortable: false,
          align: 'center',
          divider: true,
          width: 100
        },
        {
          text: 'Case Package',
          value: 'component__case_package__name',
          sortable: false,
          align: 'center',
          divider: true,
          width: 80
        },
        {text: 'Supply type', value: 'supply_type', sortable: false, align: 'center', divider: true, width: 70},
        {text: 'Image', value: 'component__image', sortable: false, align: 'center', divider: true, width: 60},
        {
          text: 'DSh',
          value: 'component__datasheet',
          sortable: false,
          align: 'center',
          divider: true,
          width: 20,
          type: 'link'
        },
        {text: 'Saved', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 10},
      ],
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>